import { render, staticRenderFns } from "./HelpCircle.vue?vue&type=template&id=016aabc6&"
import script from "./HelpCircle.vue?vue&type=script&lang=js&"
export * from "./HelpCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016aabc6')) {
      api.createRecord('016aabc6', component.options)
    } else {
      api.reload('016aabc6', component.options)
    }
    module.hot.accept("./HelpCircle.vue?vue&type=template&id=016aabc6&", function () {
      api.rerender('016aabc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/HelpCircle.vue"
export default component.exports